import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const colorBgGrey2 = 'var(--color-bg-grey-2, #FAFAFA)'
const greyLevel6 = 'var(--color-grey-4, #F2F2F2)'
import { useSelector } from 'react-redux'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'
import { useFlag } from '@calendly/feature-check-react'
import { EventLocation } from '@calendly/booking-kit'
import { BodyText } from '@calendly/ui/components/typography'
import { Loader } from '@calendly/ui/components/loader'

import { useI18n } from 'locales'
import PaymentSummary from 'components/payment/summary'
import { Links } from 'components/confirmation/links'
import Signup from 'components/signup'
import { Input, Title as SignupTitle } from 'components/signup/styles'
import Details from 'components/details'
import Marker from 'components/details/marker'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'
import Attendees from 'components/details/attendees'
import PaymentMessage from 'components/confirmation/payment_message'
import { timeNotationSelector, eventSelector } from 'selectors'
import { emailSelector } from 'selectors/invitee'
import { currentUserSelector } from 'selectors/user'
import Profile from 'components/profile'
import { notificationTypeSelector } from 'selectors/scheduling'
import { useInvitee } from 'components/use_invitee'
import ErrorAlert from 'components/error/alert'
import { eventTypeSelector } from 'root-api'

import { PollCreationCallToAction } from './poll_creation_call_to_action'
import _FooterContainer from "layout-FooterContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=FooterContainer";
import _Payment from "layout-Payment.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=Payment";
import _Header from "layout-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=Header";
import _Container from "layout-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=Container";
import _CookieSettingsButton from "layout-CookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=CookieSettingsButton";
import _StyledSignUp from "layout-StyledSignUp.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=StyledSignUp";
import _PollConfirmationFooter from "layout-PollConfirmationFooter.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=PollConfirmationFooter";
import _EmailMessageContainer from "layout-EmailMessageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/layout.js?styleId=EmailMessageContainer";


const FooterContainer = /*#__PURE__*/styled('div', null, {
  displayName: "FooterContainer",
  styles: _FooterContainer
})

const Payment = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Payment",
  styles: _Payment
})

const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

export const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const CookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "CookieSettingsButton",
  styles: _CookieSettingsButton,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const StyledSignUp = /*#__PURE__*/styled(Signup, null, {
  displayName: "StyledSignUp",
  styles: _StyledSignUp
})

export const ConfirmationFooter = ({ className, isPoll, isReconfirmation = false }) => {
  const currentUser = useSelector(currentUserSelector)
  const eventType = useSelector(eventTypeSelector)
  if (!eventType) return null

  return (
    <FooterContainer data-component="confirmation-footer" className={className}>
      <Links isReconfirmation={isReconfirmation} />
      {!eventType.unbranded && !currentUser && <StyledSignUp isPoll={isPoll} />}
      {!eventType.unbranded && currentUser && isPoll && <PollCreationCallToAction />}
    </FooterContainer>
  )
}

export const PollConfirmationFooter = /*#__PURE__*/styled(ConfirmationFooter, null, {
  displayName: "PollConfirmationFooter",
  styles: _PollConfirmationFooter,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp'),
    isPoll: true
  })
})

const EmailMessageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "EmailMessageContainer",
  styles: _EmailMessageContainer
})

const EmailConfirmationMessage = () => {
  const { i18n } = useI18n()
  return (
    <EmailMessageContainer>
      <BodyText weight="bold">
        {i18n.t('booking.templates.email_confirmation_message')}
      </BodyText>
    </EmailMessageContainer>
  )
}

export const ConfirmationDetails = () => {
  const event = useSelector(eventSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const { timezone, charge, email } = useInvitee()
  const isEmailConfirmation = useSelector(notificationTypeSelector) === 'email'
  const inviteeEmail = useSelector(emailSelector)
  const sniperLinkFeatureActive = useFlag('sb_sniper_links_feature', false)
  const shouldSeeGmailSniperLink = inviteeEmail && inviteeEmail.includes('@gmail.com') && sniperLinkFeatureActive

  if (event === undefined) return <Loader />

  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    color, name, guests
  } = event

  return (
    <div>
      <Details>
        <Marker color={color} text={name} />
        <EventTime
          source={event}
          timezone={timezone}
          timeNotation={timeNotation}
        />
        <Timezone value={timezone} />
        <EventLocation event={event} />
        <Attendees items={[email, ...guests]} />
      </Details>
      <Payment charge={charge} />
      {!shouldSeeGmailSniperLink && <PaymentMessage />}
      {isEmailConfirmation && <EmailConfirmationMessage />}
    </div>
  )
}

export const ConfirmationHeader = ({ children }) => {
  const event = useSelector(eventSelector)

  if (event === undefined) return <Loader />

  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    scheduled_profile: {
      avatar_url: avatarUrl,
      logo_url: logoUrl
    }
  } = event

  return (
    <Header data-component="confirmation-header">
      <Profile
        avatar={avatarUrl}
        logoUrl={logoUrl}
      />
      {children}
    </Header>
  )
}
